/* Import here all global assets */

// Stylesheets
import '@less/common.less'

import '../../node_modules/rrssb/css/rrssb.css'

//Images
import '../img/arrow.svg'

//Fonts
import '../fonts/FuturaPT-Book.svg';
import '../fonts/FuturaPT-Book.eot';
import '../fonts/FuturaPT-Book.ttf';
import '../fonts/FuturaPT-Book.woff';
import '../fonts/FuturaPT-Book.woff2';

import '../fonts/FuturaPT-Demi.svg';
import '../fonts/FuturaPT-Demi.eot';
import '../fonts/FuturaPT-Demi.ttf';
import '../fonts/FuturaPT-Demi.woff';
import '../fonts/FuturaPT-Demi.woff2';

import '../fonts/FuturaPT-Heavy.svg';
import '../fonts/FuturaPT-Heavy.eot';
import '../fonts/FuturaPT-Heavy.ttf';
import '../fonts/FuturaPT-Heavy.woff';
import '../fonts/FuturaPT-Heavy.woff2';



/* MEDIA: */
import '../img/docs.jpg'
import '../img/inchieste.jpg'
import '../img/story1.jpg'
import '../img/story2.jpg'
import '../img/story3.jpg'
import '../img/logo_infinity.svg'
import '../img/arrow_down.svg'
import '../img/next.svg'
import '../img/arrow_right.svg'
import '../img/checked.svg'
import '../img/arrow.svg'
import '../img/arrow_flickity.svg'



